import { Component, OnInit, Input } from '@angular/core';
import { CourseSessionsService } from '../course-sessions.service';

@Component({
    selector: 'app-course-sessions',
    templateUrl: './course-sessions.component.html',
    styleUrls: ['./course-sessions.component.scss'],
})
export class CourseSessionsComponent implements OnInit {
    @Input() display;

    constructor(private courseSessionsService: CourseSessionsService) {}

    ngOnInit(): void {
        this.get();
    }

    get(): void {
        this.courseSessionsService.get();
    }

    collapse(): void {
        if (this.isEditable) return;
        this.display = !this.display;
    }

    reload(): void {
        if (this.isEditable) return;
        this.get();
    }

    add(): void {
        if (this.isEditable) return;
        this.display = true;
        this.courseSessionsService.isAdd = true;
        this.courseSessionsService.isEditable = true;
    }

    get isAdd() {
        return this.courseSessionsService.isAdd;
    }

    get isEditable() {
        return this.courseSessionsService.isEditable;
    }

    get sessions() {
        return this.courseSessionsService.sessions;
    }

    get isLoading() {
        return this.courseSessionsService.isLoading;
    }

    get errorMessage() {
        return this.courseSessionsService.errorMessage;
    }
}